// import { Navigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import AdminLayout from '../layouts/AdminLayout';
import { useSelector } from 'react-redux';
import { getMenuItems } from '../components/UIElements/sidebarConfig';

const WithAuth = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { userDetails, userPermissions, webServices } = useSelector(
    (state) => state.auth?.successData ?? {},
  );
  const location = useLocation();
  const path = location.pathname;

  const allowedRoutesSet = new Set(
    getMenuItems(userDetails, userPermissions, webServices)?.map(
      (item) => item.route,
    ),
  );
  const isAllowed = [...allowedRoutesSet].some((route) =>
    path.startsWith(route),
  );
  if (!isAuthenticated) {
    return <Navigate to='/signin' replace />;
  }
  if (!isAllowed) {
    return <Navigate to='/unauthorized' replace />;
  }

  return <AdminLayout>{children}</AdminLayout>;
};

export default WithAuth;
